module.exports = __webpack_public_path__ + "img/share4.ebbf48cf.png";